import React from 'react';

import { Step, StepButton, Box } from '@mui/material';

import { tabPropsAreEqual } from '../../utils';
import { StepperStyled } from './stepper.style';

function Stepper({
  steps,
  children,
  activeStep,
  setActiveStep
}: {
  steps: string[];
  children: React.ReactNode;
  activeStep: number;
  setActiveStep: (value: number) => void;
}): JSX.Element {
  const handleStep = (step: number) => (): void => {
    setActiveStep(step);
  };

  return (
    <div>
      <StepperStyled alternativeLabel nonLinear activeStep={activeStep}>
        {steps.map((label, index) => {
          return (
            <Step key={label}>
              <StepButton
                onClick={handleStep(index)}
                className='stepButton'
                disabled={index >= activeStep}
              >
                {label}
              </StepButton>
            </Step>
          );
        })}
      </StepperStyled>
      {children}
    </div>
  );
}

interface StepContentProps {
  children: React.ReactNode;
  index: number;
  selected: number;
}

function StepContent({ index, selected, children }: StepContentProps): JSX.Element {
  return <Box>{selected !== index ? null : children}</Box>;
}

Stepper.Content = StepContent;
Stepper.MemoContent = React.memo(StepContent, tabPropsAreEqual);

export { Stepper };
